/**
 * 入札一覧の「見出し帯」の高さ (通常入札・ブロック入札タブで共通)。
 *
 * 帯に置くボタンは `size="md"` (= 40px) を**明示**し、器は `minHeight` ではなく `height` で
 * この値に固定する。 size 未指定で DS 既定に任せると、 DS 側の既定が変わった時に器を突き破る。
 * 8080 `spot.html` も「内部 40px ボタン + 縦 padding 8px × 2 = 56px」。
 * (以前は左のフィルターサイドバーの見出しと下線をそろえるための値だった。 サイドバーは
 * 2026-10-27 に表の上の開閉式へ置き換えて廃止した。)
 */
export const LIST_HEADER_HEIGHT = '56px'
